<div class="video-custom-block">
    <h2 class="video-custom-block__header">{{block.data.header}}</h2>

    <div class="video-custom-block__video-container">
        <div class="video-custom-block__video-inner">
            <div
                class="video-custom-block__video-wrapper video ratio_16-9" 
                (click)="playVideo()"
                [ngStyle]="{backgroundImage: block.data.image_url ? 'url(' + block.data.image_url + ')' : null}"
                [ngClass]="{'video-custom-block__video-wrapper--playing': isPlaying}"
            >
                <video #video class="video-custom-block__video" [controls]="isPlaying ? 'controls' : null">
                    <source [src]="videoSrc" type="video/mp4" />
                    </video>
            </div>
        </div>
    </div>
</div>
